/* ============================================================================
FILE: po-katupirsia5-syntonea-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5SyntoneaTextsFR_EN_ES_20260312
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_SYNTONEA_TEXTS_20260312__) return;
  window.__PO_K5_SYNTONEA_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="syntonea"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) {
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Système posœnnoïal",
      "Organon posœnnoïal",
      "Posœnnoïamie",
      "Posœnnomia",
      "Katûpirsia",
      "Katûvýs",
      "Katûsýs",
      "Katûvýsqun",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone régulateur",
      "Sceau de Syntonie",
      "Sceau d’Équiphase",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí",
      "Sceau d’Ọ̀rọ̀yuyay",
      "Sceau de Yuyarina",
      "Sceau d’Œndomare",
      "Syntōnēa",
      "Ēkuphasa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Takimarah",
      "Ušôprogalenmestûd",
      "Pistis Chraomai",
      "RéZonans",
      "RéZonanser",
      "RéZoindre",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Stratification d’expériences",
      "Expérience fragmentée",
      "Conscientisation introspective",
      "Conscientisation dynamique",
      "Conscience vibratoire",
      "Lucidité critique",
      "Lucidité structurante",
      "Adaptabilité critique",
      "Adaptabilité ouverte",
      "Approche fluide et adaptative",
      "Déterminisme du choix",
      "Myrte décisif",
      "Néotaxie",
      "Identité évolutive",
      "Exploration de l’inconnu",
      "Miroirs posœnnoïaux",
      "Fréquence 492",
      "Fréquence-guide",
      "Nombre-guide",
      "Humanus",
      "MOCoN",
      "Àpákan"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  var CANONICAL_OVERRIDES = [
    [/\bGuide-number\b/gi, "Nombre-guide"],
    [/\bGuide number\b/gi, "Nombre-guide"],
    [/\bGuide-frequency\b/gi, "Fréquence-guide"],
    [/\bGuide frequency\b/gi, "Fréquence-guide"],
    [/\bN[uú]mero-gu[ií]a\b/gi, "Nombre-guide"],
    [/\bFrecuencia-gu[ií]a\b/gi, "Fréquence-guide"],
    [/\bFrequency 492\b/gi, "Fréquence 492"],
    [/\bFrecuencia 492\b/gi, "Fréquence 492"],
    [/\bSeal of Syntony\b/gi, "Sceau de Syntonie"],
    [/\bSello de Sinton[ií]a\b/gi, "Sceau de Syntonie"],
    [/\bPlural subject\b/gi, "Sujet pluriel"],
    [/\bSujeto plural\b/gi, "Sujet pluriel"],
    [/\bMultiple instantaneity\b/gi, "Instantané multiple"],
    [/\bInstant[aá]neo m[uú]ltiple\b/gi, "Instantané multiple"],
    [/\bSuperposition of perspectives\b/gi, "Superposition de perspectives"],
    [/\bSuperposici[oó]n de perspectivas\b/gi, "Superposition de perspectives"],
    [/\bExpanded temporality\b/gi, "Temporalité élargie"],
    [/\bTemporalidad extensiva\b/gi, "Temporalité élargie"],
    [/\bBroken-out temporality\b/gi, "Temporalité éclatée"],
    [/\bTemporalidad estallada\b/gi, "Temporalité éclatée"],
    [/\bPosœnnoïal meditations\b/gi, "Méditations Posœnnoïales"],
    [/\bMeditaciones posœnnoïales\b/gi, "Méditations Posœnnoïales"],
    [/\bPosœnnoïal agreements\b/gi, "Accords Posœnnoïaux"],
    [/\bAcuerdos posœnnoïaux\b/gi, "Accords Posœnnoïaux"],
    [/\bPosœnnoïal Organon\b/gi, "Organon posœnnoïal"],
    [/\bSyntony\b/gi, "syntonie"],
    [/\bSinton[ií]a\b/gi, "syntonie"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  var CONTENT = {
    fr: {
      title: "Syntōnēa",
      kicker: "Entité isqunienne de Threnisqun — réajustement des déphasages vibratoires.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Syntonea_opie.png?v=1772923043", alt: "Idéogramme de Syntōnēa" },

      h_def: "Définition canonique",

      chip_1: "Sceau associé : Sceau de Syntonie",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_de_Syntonie_593_2.png?v=1772896047", alt: "Sceau de Syntonie" },
      chip_2: "Fréquence d’alignement 593",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_593.png?v=1773448635", alt: "Nombre-guide 593" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Syntōnēa</strong> capte les désaccords fréquentiels, retisse les fibres vibratoires rompues et rétablit une syntonie active sans réduire la pluralité.",

      def_long:
        "<p>Dans <strong>Katûpirsia 5</strong>, <strong>Syntōnēa</strong> est l’entité posœnnoïale qui régule les déphasages internes, qu’ils soient corporels, émotionnels, mentaux ou environnementaux. Elle intervient là où la fréquence naturelle d’un être, d’un lieu ou d’une action se désaccorde de son axe de syntonie sans se rompre.</p>" +
        "<p>Elle n’uniformise pas. Elle agit comme intelligence de l’accord, réaccueille la pluralité des fréquences en mouvement et ouvre l’espace où une tenue commune peut se reformer.</p>",

      h_grid: "Statut vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Accordeur transdimensionnel de Threnisqun",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "593",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Déphasages corporels, émotionnels, mentaux et contextuels</li>" +
        "<li>Réintégration des fragments désaccordés : souvenir, parole, relation</li>" +
        "<li>Stabilisation des zones trop intenses ou trop étouffées</li>" +
        "<li>Activation des sons justes, couleurs justes, mouvements justes</li>" +
        "</ul>",

      h_intro: "Posture propre",
      p_intro:
        "<p><strong>Syntōnēa</strong> se manifeste lorsque tout paraît juste séparément mais dissonant ensemble. Son geste travaille la coexistence active des fréquences hétérogènes : elle ne fusionne pas, elle retisse.</p>" +
        "<p>Elle circule à travers corps, sons, pensées, souvenirs et relations, et intervient lorsque le choc, l’oubli, la confusion ou l’accélération ont rompu des fibres vibratoires qu’un simple retour à l’ordre ne suffirait pas à réaccorder.</p>",

      h_actions: "Fonctions rituelles",
      actions:
        "<ol>" +
        "<li>Réaligner un champ fréquentiel en contexte de dissonance interne ou externe.</li>" +
        "<li>Reconstruire un axe vibratoire individuel après dispersion ou confusion.</li>" +
        "<li>Réintégrer des fragments désaccordés : souvenir, parole, relation, perception.</li>" +
        "<li>Stabiliser une zone émotionnelle trop intense ou trop étouffée.</li>" +
        "<li>Réactiver l’écoute poïétique par les sons justes, les couleurs justes et les mouvements justes.</li>" +
        "</ol>",

      h_phrase: "Formules d’usage",
      phrase:
        "<p>« Syntōnēa accorde. »</p>" +
        "<p>« Syntōnēa réaligne. »</p>" +
        "<p>« Syntōnēa retisse. »</p>" +
        "<p>« Celle qui rallume les accords invisibles et réaccueille les harmoniques éteintes. »</p>",

      h_table: "Tableau d’usage",
      table_head_1: "Situation",
      table_head_2: "Signe",
      table_head_3: "Action de Syntōnēa",
      table_rows:
        "<tr><td>Tout est juste séparément mais dissonant ensemble</td><td>Cohérence locale, désaccord global</td><td>Syntōnēa accorde</td></tr>" +
        "<tr><td>Émotion ou relation qui se dérègle sans rupture</td><td>Tension flottante, axe brouillé</td><td>Syntōnēa réaligne</td></tr>" +
        "<tr><td>Deux vérités coexistent sans fusion possible</td><td>Friction féconde, incompatibilité apparente</td><td>Syntōnēa retisse</td></tr>" +
        "<tr><td>Présence pacifiée après désaccord</td><td>Respiration plus juste, tenue retrouvée</td><td>Syntōnēa stabilise sans uniformiser</td></tr>",

      h_entite: "Nom — formation canonique",
      entite_kicker: "Synt- + -ōnēa",
      entite_body:
        "<p>La formation canonique donnée par le corpus est explicite : <strong>Synt-</strong> renvoie à la réunion, à l’accord et à l’ajustement relationnel ; <strong>-ōnēa</strong> nomme une résonance prolongée, une tenue vibratoire dans la durée.</p>" +
        "<p>Le nom porte ainsi une fonction précise : rallumer les accords invisibles et réaccueillir les harmoniques éteintes sans effacer la pluralité des fréquences en présence.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Résonance du cœur différé",
      ritual_steps:
        "<ol>" +
        "<li>Se tenir debout, yeux fermés, bras ouverts en silence.</li>" +
        "<li>Prononcer mentalement ou à voix basse le mot Syntōnēa en trois temps : SYN – TŌ – NĒA.</li>" +
        "<li>Puis produire un son vibré doux, selon sa propre voix, en partant de la poitrine.</li>" +
        "<li>Visualiser un tissage lumineux s’étendant en réseau depuis le sternum.</li>" +
        "<li>Clore lorsque la pluralité redevient habitable, sans fusion ni écrasement.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Après une dispute, une crise de désaccord ou une intense confusion émotionnelle</li>" +
        "<li>En fin de journée pour récupérer les fragments dispersés</li>" +
        "<li>Lors de la préparation d’une création collective</li>" +
        "<li>Dans les états de réconciliation intérieure ou de friction féconde</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Taxiêlîs</strong> — points d’interconnexion : Syntōnēa active l’accord entre les seuils</li>" +
        "<li><strong>Takimarah</strong> — réajustement des modalités opératives désaccordées</li>" +
        "<li><strong>Katûvýsissence</strong> — réveil des mémoires enfouies par la désyntonisation</li>" +
        "<li><strong>Posœnnomia</strong> — préside aux pratiques de recomposition collective vibratoire</li>" +
        "<li><strong>Pistis Chraomai</strong> — syntonie intérieure par activation de l’écoute vibratoire</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Syntōnēa",
      kicker: "Entité isqunienne de Threnisqun — readjustment of vibratory phase shifts.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Syntonea_opie.png?v=1772923043", alt: "Idéogramme de Syntōnēa" },

      h_def: "Canonical definition",

      chip_1: "Sceau de Syntonie",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_de_Syntonie_593_2.png?v=1772896047", alt: "Sceau de Syntonie" },
      chip_2: "Fréquence d’alignement 593",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_593.png?v=1773448635", alt: "Nombre-guide 593" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Syntōnēa</strong> captures frequency mismatches, reweaves broken vibratory fibers, and restores a syntonie active without reducing plurality.",

      def_long:
        "<p>In <strong>Katûpirsia 5</strong>, <strong>Syntōnēa</strong> is the posœnnoïal entity that regulates internal phase shifts, whether bodily, emotional, mental, or environmental. It intervenes where the natural frequency of a being, a place, or an action falls out of tune with its axis of syntonie without breaking.</p>" +
        "<p>It does not homogenize. It acts as an intelligence of accord, welcoming back the plurality of frequencies in motion and reopening the space where a common breathable holding can reform.</p>",

      h_grid: "Vibratory status",
      grid_type_label: "Type",
      grid_type_value: "Transdimensional tuner of Threnisqun",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "593",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Bodily, emotional, mental, and contextual phase shifts</li>" +
        "<li>Reintegration of mismatched fragments: memory, speech, relation</li>" +
        "<li>Stabilization of zones that are too intense or too muted</li>" +
        "<li>Activation of right sounds, right colors, right movements</li>" +
        "</ul>",

      h_intro: "Proper posture",
      p_intro:
        "<p><strong>Syntōnēa</strong> appears when everything seems right separately yet dissonant together. Its gesture works on the active coexistence of heterogeneous frequencies: it does not fuse, it reweaves.</p>" +
        "<p>It circulates through bodies, sounds, thoughts, memories, and relations, and intervenes where shock, forgetting, confusion, or acceleration have broken vibratory fibers that cannot be restored by mere order alone.</p>",

      h_actions: "Ritual functions",
      actions:
        "<ol>" +
        "<li>Realign a frequency-field in contexts of internal or external dissonance.</li>" +
        "<li>Rebuild an individual vibratory axis after dispersion or confusion.</li>" +
        "<li>Reintegrate mismatched fragments: memory, speech, relation, perception.</li>" +
        "<li>Stabilize an emotional zone that is too intense or too muted.</li>" +
        "<li>Reactivate poïetic listening through right sounds, right colors, and right movements.</li>" +
        "</ol>",

      h_phrase: "Usage formulas",
      phrase:
        "<p>“Syntōnēa accords.”</p>" +
        "<p>“Syntōnēa realigns.”</p>" +
        "<p>“Syntōnēa reweaves.”</p>" +
        "<p>“The one who rekindles invisible accords and welcomes back extinguished harmonics.”</p>",

      h_table: "Usage table",
      table_head_1: "Situation",
      table_head_2: "Sign",
      table_head_3: "Action of Syntōnēa",
      table_rows:
        "<tr><td>Everything is right separately yet dissonant together</td><td>Local coherence, global mismatch</td><td>Syntōnēa accords</td></tr>" +
        "<tr><td>An emotion or a relation goes out of tune without rupture</td><td>Floating tension, blurred axis</td><td>Syntōnēa realigns</td></tr>" +
        "<tr><td>Two truths coexist without possible fusion</td><td>Fruitful friction, apparent incompatibility</td><td>Syntōnēa reweaves</td></tr>" +
        "<tr><td>Pacified presence after disagreement</td><td>Breath becomes clearer, holding returns</td><td>Syntōnēa stabilizes without homogenizing</td></tr>",

      h_entite: "Name — canonical formation",
      entite_kicker: "Synt- + -ōnēa",
      entite_body:
        "<p>The canonical formation given by the corpus is explicit: <strong>Synt-</strong> refers to gathering, accord, and relational adjustment; <strong>-ōnēa</strong> names a prolonged resonance, a vibratory holding through duration.</p>" +
        "<p>The name therefore carries a precise function: to rekindle invisible accords and welcome back extinguished harmonics without erasing the plurality of frequencies in presence.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Résonance du cœur différé",
      ritual_steps:
        "<ol>" +
        "<li>Stand upright, eyes closed, arms open in silence.</li>" +
        "<li>Pronounce inwardly or in a low voice the word Syntōnēa in three beats: SYN – TŌ – NĒA.</li>" +
        "<li>Then produce a soft vibrated sound from the chest, according to your own voice.</li>" +
        "<li>Visualize a luminous weaving extending in network from the sternum.</li>" +
        "<li>Close when plurality becomes inhabitable again, without fusion or flattening.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>After a dispute, a crisis of disagreement, or intense emotional confusion</li>" +
        "<li>At the end of the day to gather dispersed fragments</li>" +
        "<li>During the preparation of a collective creation</li>" +
        "<li>In states of inner reconciliation or fruitful friction</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Taxiêlîs</strong> — Syntōnēa activates accord between thresholds</li>" +
        "<li><strong>Takimarah</strong> — readjustment of mismatched operative modalities</li>" +
        "<li><strong>Katûvýsissence</strong> — awakens memories buried by desyntonization</li>" +
        "<li><strong>Posœnnomia</strong> — presides over practices of collective vibratory recomposition</li>" +
        "<li><strong>Pistis Chraomai</strong> — syntonie intérieure through activation de l’écoute vibratoire</li>" +
        "</ul>",

      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Syntōnēa",
      kicker: "Entité isqunienne de Threnisqun — reajuste de los desfases vibratorios.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Syntonea_opie.png?v=1772923043", alt: "Idéogramme de Syntōnēa" },

      h_def: "Definición canónica",

      chip_1: "Sceau de Syntonie",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_de_Syntonie_593_2.png?v=1772896047", alt: "Sceau de Syntonie" },
      chip_2: "Fréquence d’alignement 593",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_593.png?v=1773448635", alt: "Nombre-guide 593" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Syntōnēa</strong> capta los desacuerdos frecuenciales, reteje las fibras vibratorias rotas y restablece una syntonie active sin reducir la pluralidad.",

      def_long:
        "<p>En <strong>Katûpirsia 5</strong>, <strong>Syntōnēa</strong> es la entidad posœnnoïal que regula los desfases internos, ya sean corporales, emocionales, mentales o ambientales. Interviene allí donde la frecuencia natural de un ser, un lugar o una acción se desajusta de su axe de syntonie sin romperse.</p>" +
        "<p>No uniformiza. Actúa como inteligencia del acuerdo, reacepta la pluralidad de las frecuencias en movimiento y reabre el espacio donde una tenida común respirable puede reformarse.</p>",

      h_grid: "Estado vibratorio",
      grid_type_label: "Tipo",
      grid_type_value: "Afinador transdimensional de Threnisqun",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "593",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Desfases corporales, emocionales, mentales y contextuales</li>" +
        "<li>Reintegración de fragmentos desajustados: recuerdo, palabra, relación</li>" +
        "<li>Estabilización de zonas demasiado intensas o demasiado sofocadas</li>" +
        "<li>Activación de sonidos justos, colores justos y movimientos justos</li>" +
        "</ul>",

      h_intro: "Postura propia",
      p_intro:
        "<p><strong>Syntōnēa</strong> aparece cuando todo parece justo por separado pero disonante en conjunto. Su gesto trabaja la coexistencia activa de frecuencias heterogéneas: no fusiona, reteje.</p>" +
        "<p>Circula a través de cuerpos, sonidos, pensamientos, recuerdos y relaciones, e interviene cuando el choque, el olvido, la confusión o la aceleración han roto fibras vibratorias que un simple retorno al orden no bastaría para reajustar.</p>",

      h_actions: "Funciones rituales",
      actions:
        "<ol>" +
        "<li>Realinear un campo frecuencial en contextos de disonancia interna o externa.</li>" +
        "<li>Reconstruir un eje vibratorio individual tras dispersión o confusión.</li>" +
        "<li>Reintegrar fragmentos desajustados: recuerdo, palabra, relación, percepción.</li>" +
        "<li>Estabilizar una zona emocional demasiado intensa o demasiado sofocada.</li>" +
        "<li>Reactivar la escucha poïética mediante sonidos justos, colores justos y movimientos justos.</li>" +
        "</ol>",

      h_phrase: "Fórmulas de uso",
      phrase:
        "<p>« Syntōnēa acuerda. »</p>" +
        "<p>« Syntōnēa realinea. »</p>" +
        "<p>« Syntōnēa reteje. »</p>" +
        "<p>« La que reenciende los acuerdos invisibles y reacepta las armónicas apagadas. »</p>",

      h_table: "Tabla de uso",
      table_head_1: "Situación",
      table_head_2: "Signo",
      table_head_3: "Acción de Syntōnēa",
      table_rows:
        "<tr><td>Todo es justo por separado pero disonante en conjunto</td><td>Coherencia local, desacuerdo global</td><td>Syntōnēa acuerda</td></tr>" +
        "<tr><td>Una emoción o una relación se desajusta sin ruptura</td><td>Tensión flotante, eje borroso</td><td>Syntōnēa realinea</td></tr>" +
        "<tr><td>Dos verdades coexisten sin fusión posible</td><td>Fricción fértil, incompatibilidad aparente</td><td>Syntōnēa reteje</td></tr>" +
        "<tr><td>Presencia pacificada tras el desacuerdo</td><td>La respiración se vuelve más justa, la tenida retorna</td><td>Syntōnēa estabiliza sin uniformizar</td></tr>",

      h_entite: "Nombre — formación canónica",
      entite_kicker: "Synt- + -ōnēa",
      entite_body:
        "<p>La formación canónica dada por el corpus es explícita: <strong>Synt-</strong> remite a reunión, acuerdo y ajuste relacional; <strong>-ōnēa</strong> nombra una resonancia prolongada, una tenida vibratoria en la duración.</p>" +
        "<p>El nombre porta así una función precisa: reencender acuerdos invisibles y reaceptar armónicas apagadas sin borrar la pluralidad de frecuencias presentes.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Résonance du cœur différé",
      ritual_steps:
        "<ol>" +
        "<li>Permanecer de pie, ojos cerrados, brazos abiertos en silencio.</li>" +
        "<li>Pronunciar mentalmente o en voz baja la palabra Syntōnēa en tres tiempos : SYN – TŌ – NĒA.</li>" +
        "<li>Luego producir un sonido vibrado suave desde el pecho, según la propia voz.</li>" +
        "<li>Visualizar un tejido luminoso extendiéndose en red desde el esternón.</li>" +
        "<li>Cerrar cuando la pluralidad vuelva a ser habitable, sin fusión ni aplastamiento.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Después de una disputa, una crisis de desacuerdo o una intensa confusión emocional</li>" +
        "<li>Al final del día para recuperar los fragmentos dispersos</li>" +
        "<li>Durante la preparación de una creación colectiva</li>" +
        "<li>En estados de reconciliación interior o de fricción fecunda</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Taxiêlîs</strong> — Syntōnēa activa el acuerdo entre los umbrales</li>" +
        "<li><strong>Takimarah</strong> — reajuste de modalidades operativas desajustadas</li>" +
        "<li><strong>Katûvýsissence</strong> — despierta memorias enterradas por la desintonización</li>" +
        "<li><strong>Posœnnomia</strong> — preside prácticas de recomposición vibratoria colectiva</li>" +
        "<li><strong>Pistis Chraomai</strong> — syntonie intérieure por activación de l’écoute vibratoire</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try {
        PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle");
      } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) {
        cur += " " + piece;
      } else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", kind: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, kind: "block", text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = (normLang(lang) || "fr");
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;
    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) {
      meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    } else if (defShort && defShort.parentNode) {
      defShort.parentNode.insertBefore(generalBtn, defShort);
    } else if (firstDetails && firstDetails.parentNode) {
      firstDetails.parentNode.insertBefore(generalBtn, firstDetails);
    }

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "phrase",
      "table_rows", "entite_body", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");

    syncDocumentLang(safeLang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }
    initAudioEverywhere(safeLang);

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5SyntoneaInit) return;
    root.__poK5SyntoneaInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5SyntoneaTextsFR_EN_ES_20260312 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    }catch(e){}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
